import StatusChip from 'components/@extended/StatusChip';

export const TimecardEmployeeLabel = ({ name }: { name: string }): JSX.Element => {
    return <StatusChip type="info" label={name} />;
};
